// extracted by mini-css-extract-plugin
export default {"publicLayout":"PublicLayout_publicLayout__B5yfo","logoKpn":"PublicLayout_logoKpn__m9+-1","logoCyberTwice":"PublicLayout_logoCyberTwice__og755","hidden":"PublicLayout_hidden__b9zli"};